export default [
  {
    title: 'Undergrad Mentor Guide',
    url: 'https://res.zailairen.com/msp/docs/ugd/mentor/1.2/Undergraduate%20Mentor%20Guide%202019.pdf',
    roles: []
  },
  {
    title: 'Mentor User Manual',
    url: 'https://res.zailairen.com/msp/docs/ugd/mentor/1.2/MSP%20Mentor%20User%20Manual%20-%20Undergraduate.pdf',
    roles: []
  },
  {
    title: 'Zoom User Manual',
    url: 'https://res.zailairen.com/msp/docs/ugd/mentor/1.2/Zoom%20User%20Manual%20-%20For%20Mentor%202018%20V1.pdf',
    roles: []
  },
  {
    title: 'Offline Timesheet Template',
    url: 'https://res.zailairen.com/msp/docs/ugd/mentor/1.2/Undergrad%20Mentor%20Timesheet%202019-20_First%20Name%20Last%20Name.xlsx',
    roles: []
  }
]
